export function convertPixelsToRem(px) {
  // Gets font size of root element of the document
  const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);

  // console.log(px / rootFontSize);
  return px / rootFontSize;
}


export function convertRemToPixels(rem) {
  // Gets font size of root element of the document
  const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);

  // console.log(rem * rootFontSize);
  return rem * rootFontSize;
}


export function getViewport() {
  var w = Math.max(
    document.documentElement.clientWidth,
    window.innerWidth || 0
  );
  var h = Math.max(
    document.documentElement.clientHeight,
    window.innerHeight || 0
  );
  var dim = { width: w, height: h };
  return dim;
}


/**
 * watchAwaitSelector
 * * Uses mutation observer to watch for 'selector' involved in DOM changes (added, removed, class change, content change, etc)
 * @param {Function} callback A callback function to be run whenever DOM changes are detected, can be anonymous or named
 * @param {String} selector Element(s) to look for involved in DOM changes, you can watch multiple selectors by separating via comma '.class1, .class2, #id3'
 * @param {Node} rootNode Node to watch from, typically document
 * @param {Number} fallbackDelay Interval to be used if the browser does not support MutationObserver, value is in milliseconds (2000 = 2 seconds)
 */
export const awaitSelector = (selector, rootNode, fallbackDelay) => new Promise((resolve, reject) => {
  try {
    const root = rootNode || document
    const ObserverClass = MutationObserver || WebKitMutationObserver || null
    const mutationObserverSupported = typeof ObserverClass === 'function'
    let observer
    const stopWatching = () => {
      if (observer) {
        if (mutationObserverSupported) {
          observer.disconnect()
        } else {
          clearInterval(observer)
        }
        observer = null
      }
    }
    const findAndResolveElements = () => {
      const allElements = root.querySelectorAll(selector)
      if (allElements.length === 0) return
      const newElements = []
      const attributeForBypassing = 'data-awaitselector-resolved'
      allElements.forEach((el, i) => {
        if (typeof el[attributeForBypassing] === 'undefined') {
          allElements[i][attributeForBypassing] = ''
          newElements.push(allElements[i])
        }
      })
      if (newElements.length > 0) {
        stopWatching()
        resolve(newElements)
      }
    }
    if (mutationObserverSupported) {
      observer = new ObserverClass(mutationRecords => {
        const nodesWereAdded = mutationRecords.reduce(
          (found, record) => found || (record.addedNodes && record.addedNodes.length > 0),
          false
        )
        if (nodesWereAdded) {
          findAndResolveElements()
        }
      })
      observer.observe(root, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeOldValue: true,
        characterData: true,
        characterDataOldValue: true
      })
    } else {
      observer = setInterval(findAndResolveElements, fallbackDelay || 250)
    }
    findAndResolveElements()
  } catch (exception) {
    reject(exception)
  }
})

export const watchAwaitSelector = (callback, selector, rootNode, fallbackDelay) => {
  (function awaiter(continueWatching = true) {
    if (continueWatching === false) return
    awaitSelector(selector, rootNode, fallbackDelay)
      .then(callback)
      .then(awaiter)
  }())
}


export function matchHeight(selector, resetBetween = false) {

    var elements = document.querySelectorAll(selector);
    var tallest = 0;

    if(elements.length > 0) {
      if(resetBetween === true) {
        // Set element heights back to their default (auto)
        for(var i = 0; i < elements.length; i++) {
          var ele = elements[i];
          // ele.setAttribute("style","height:auto");
          ele.style.height = "auto";
        }
      }

      // Get height of tallest element
      for(var i = 0; i < elements.length; i++) {
          var ele = elements[i];
          var eleHeight = ele.getBoundingClientRect().height;
          tallest = (eleHeight>tallest ? eleHeight : tallest);
      }

      // Set each element to match height of tallest element
      for(var i = 0; i < elements.length; i++) {
          elements[i].style.height = convertPixelsToRem(tallest) + 'rem';
          // setAttribute("style",`height:${tallest}px`);
      }
    }
}

export function matchWidth(selector) {
    var elements = document.querySelectorAll(selector);
    var widest = 0;

    if(elements.length > 0) {
      for(var i = 0; i < elements.length; i++) {
          var ele = elements[i];
          // var eleWidth = ele.offsetWidth;
          var eleWidth = ele.getBoundingClientRect().width;
          widest = (eleWidth>widest ? eleWidth : widest);
      }

      for(var i = 0; i < elements.length; i++) {
          elements[i].style.width = convertPixelsToRem(widest) + "rem";
      }
    }
}


export function setHeightAuto(selector) {
  var elements = document.querySelectorAll(selector);
  for(let e of elements) {
    e.style.height = "auto";
  }
}

export function throttle(type, name, obj) {
  var running = false;

  obj = obj || window;

  var func = function() {
    if (running) return;

    running = true;

    requestAnimationFrame(function() {
      obj.dispatchEvent(new CustomEvent(name));
      running = false;
    });
  };

   obj.addEventListener(type, func);
}

export function debounce(func, wait, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
}


export function makeSquareFromWidth(selector) {
  const items = document.querySelectorAll(selector);
  for(const item of items) {
    const width = item.getBoundingClientRect().width;
    // item.style.height = width + 'px';
    item.style.height = convertPixelsToRem(width) + 'rem';
  }
}

export function makeSquareFromHeight(selector) {
  const items = document.querySelectorAll(selector);
  for(const item of items) {
    const height = item.getBoundingClientRect().height;
    // item.style.width = height + 'px';
    item.style.width = convertPixelsToRem(height) + 'rem';
  }
}


export function insertAfter(el, referenceNode) {
    referenceNode.parentNode.insertBefore(el, referenceNode.nextSibling);
}


export function resizeLineWidth() {
  let activeWord = document.querySelector('.connect__word.active');
  if(activeWord) {
    let activeLine = activeWord.querySelector('.connect__line');

    if(activeWord && activeWord.dataset.connect && activeLine) {
      let connectedBox = document.getElementById(activeWord.dataset.connect);

      if(connectedBox) {
        let wordOffset = 20;
        let wordRect = activeWord.getBoundingClientRect();
        let boxRect = connectedBox.getBoundingClientRect();

        let lineWidth = calculateLineWidth(wordOffset, wordRect, boxRect, connectedBox);

        activeLine.style.width = lineWidth + 'px';
      }
    }
  }
}


export function calculateLineWidth(wordOffset, wordRect, boxRect, boxEl) {
  let wordRightEdge = wordRect.x + wordRect.width + wordOffset;
  let boxLeftPadding = parseFloat(window.getComputedStyle(boxEl, null).getPropertyValue('padding-left'));
  let width = boxRect.x - wordRightEdge + (boxLeftPadding / 2);

  return width;
}


export function removeClassFromAll(elements, className) {
  if(elements.length > 0) {
    for(let element of elements) {
      element.classList.remove(className);
    }
  }
}

export function equalHeights(selector) {
    let elements = document.querySelectorAll(selector);
    let tallest = 0;

    for(let i = 0; i < elements.length; i++) {
        let ele = elements[i];
        let eleHeight = ele.offsetHeight;
        tallest = (eleHeight>tallest ? eleHeight : tallest);
    }

    for(let i = 0; i < elements.length; i++) {
        elements[i].style.height = tallest + "px";
    }
}

export function equalWidths(selector) {
    let elements = document.querySelectorAll(selector);
    let widest = 0;

    for(let i = 0; i < elements.length; i++) {
        let ele = elements[i];
        let eleWidth = ele.offsetWidth;
        widest = (eleWidth>widest ? eleWidth : widest);
    }

    for(let i = 0; i < elements.length; i++) {
        elements[i].style.width = widest + "px";
    }
}
